import { ORIGINS } from 'constants/constants';

export function getOrigin(userKey) {
  return Object.values(ORIGINS).find((data) => data.slug === userKey) || '';
}
